module.exports = __webpack_public_path__ + "static/media/report2.0960d22a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/report2.jpg
// module id = 2059
// module chunks = 0